<div class="status-page">
  <!-- Header Section - Full Width -->
  <div class="header-section">
    <div class="union-logo">
      <img src="assets/img/bangladesh-logo.png" alt="Bangladesh Logo" class="logo" onerror="this.style.display='none'">
    </div>
    <div class="header-content">
      <h1 class="union-title">{{unionDomain.unionData.union_name}}</h1>
      <p class="union-subtitle">উপজেলা: {{unionDomain.unionData.upozilla_name}}, জেলা: {{unionDomain.unionData.zilla_name}}</p>
      <div class="page-title">
        <h2>ট্যাক্স পেমেন্ট স্ট্যাটাস</h2>
        <p>QR কোড স্ক্যান করে আপনার ট্যাক্সের তথ্য দেখুন</p>
      </div>
    </div>
  </div>

  <div class="container">
    <!-- Status Cards Section -->
    <div class="status-cards" *ngIf="assessment && assessment.name">
             <!-- Property Information Card -->
       <div class="info-card property-card">
         <div class="card-header">
           <span class="card-icon">🏠</span>
           <h3>সম্পত্তির তথ্য</h3>
         </div>
        <div class="card-content">
          <div class="info-row">
            <span class="label">মালিকের নাম:</span>
            <span class="value">{{assessment.name}}</span>
          </div>
          <div class="info-row">
            <span class="label">হোল্ডিং নং:</span>
            <span class="value">{{assessment.holding_number}}</span>
          </div>
          <div class="info-row">
            <span class="label">ওয়ার্ড নং:</span>
            <span class="value">{{unionDomain.convertEnglishHoldingNumberToBanglaHoldingNumber(assessment.ward_number.toString())}}</span>
          </div>
          <div class="info-row">
            <span class="label">গ্রাম/এলাকা:</span>
            <span class="value">{{assessment.gram_or_rasta}}</span>
          </div>
        </div>
      </div>

             <!-- Tax Information Card -->
       <div class="info-card tax-card">
         <div class="card-header">
           <span class="card-icon">💰</span>
           <h3>ট্যাক্স হিসাব (২০২৪-২০২৫)</h3>
         </div>
        <div class="card-content">
          <div class="tax-summary">
            <div class="tax-item total-tax">
              <div class="tax-label">মোট ট্যাক্স</div>
              <div class="tax-amount">৳{{totalTax | number:'1.2-2'}}</div>
            </div>
            <div class="tax-item paid-tax">
              <div class="tax-label">পরিশোধিত</div>
              <div class="tax-amount paid">৳{{aday | number:'1.2-2'}}</div>
            </div>
            <div class="tax-item due-tax" [ngClass]="{'danger': tax > 0, 'success': tax <= 0}">
              <div class="tax-label">বকেয়া</div>
              <div class="tax-amount">৳{{tax | number:'1.2-2'}}</div>
            </div>
          </div>
          
                     <div class="status-indicator" [ngClass]="{'paid': tax <= 0, 'due': tax > 0}">
             <div class="status-icon">
               <span class="status-emoji">{{tax <= 0 ? '✅' : '⚠️'}}</span>
             </div>
             <div class="status-text">
               <span *ngIf="tax <= 0" class="status-paid">সম্পূর্ণ পরিশোধিত</span>
               <span *ngIf="tax > 0" class="status-due">পেমেন্ট বকেয়া আছে</span>
             </div>
           </div>
        </div>
      </div>

             <!-- Payment History Card -->
       <div class="info-card history-card" *ngIf="taxList && taxList.length > 0">
         <div class="card-header">
           <span class="card-icon">📋</span>
           <h3>পেমেন্ট ইতিহাস</h3>
         </div>
        <div class="card-content">
          <div class="history-list" *ngIf="getPaymentHistory().length > 0">
            <div class="history-item" *ngFor="let payment of getPaymentHistory()">
              <div class="payment-header">
                <div class="payment-date">
                  {{payment.createdAt | date:'dd/MM/yyyy'}}
                </div>
                <div class="payment-type payment">
                  পেমেন্ট
                </div>
              </div>
              <div class="payment-footer">
                <div class="payment-amount credit">
                  ৳{{payment.amount | number:'1.2-2'}}
                </div>
                <div class="payment-year">
                  {{payment.financial_year}}-{{payment.financial_year + 1}}
                </div>
              </div>
            </div>
          </div>
          <div class="no-payments" *ngIf="getPaymentHistory().length === 0">
            <div class="no-payments-icon">
              <span class="no-payment-emoji">🧾</span>
            </div>
            <p>এখনো কোনো পেমেন্ট করা হয়নি</p>
          </div>
        </div>
      </div>

             <!-- Contact Information -->
       <div class="info-card contact-card">
         <div class="card-header">
           <span class="card-icon">📞</span>
           <h3>যোগাযোগ</h3>
         </div>
        <div class="card-content">
          <p>ট্যাক্স পেমেন্ট বা অন্য কোনো তথ্যের জন্য ইউনিয়ন পরিষদের সাথে যোগাযোগ করুন।</p>
                     <div class="contact-actions">
             <button class="contact-btn" onclick="window.location.href='tel:+8801700000000'">
               <span class="btn-icon">📞</span>
               ফোন করুন
             </button>
             <button class="contact-btn" onclick="window.print()">
               <span class="btn-icon">🖨️</span>
               প্রিন্ট করুন
             </button>
           </div>
        </div>
      </div>
    </div>

    <!-- Loading State -->
    <div class="loading-state" *ngIf="!assessment || !assessment.name">
      <div class="loading-emoji">⏳</div>
      <p>তথ্য লোড হচ্ছে...</p>
    </div>

    <!-- Error State -->
    <div class="error-state" *ngIf="qr_code && assessment && !assessment.name">
      <div class="error-icon">
        <span class="error-emoji">❗</span>
      </div>
      <h3>কোনো তথ্য পাওয়া যায়নি</h3>
      <p>এই QR কোডের জন্য কোনো রেকর্ড খুঁজে পাওয়া যায়নি। অনুগ্রহ করে সঠিক QR কোড স্ক্যান করুন।</p>
    </div>

    <!-- Footer -->
    <div class="page-footer">
      <p>© {{getCurrentYear()}} {{unionDomain.unionData.union_name}} - সকল অধিকার সংরক্ষিত</p>
      <small>ডিজিটাল বাংলাদেশের অংশ হিসেবে ডিজিটাল ইউনিয়ন সেবা</small>
    </div>
  </div>
</div>